module.exports = __webpack_public_path__ + "img/test_embodimetria.aff7b62f.jpeg";